export default "__VITE_PUBLIC_ASSET__0a408f23__"